import { render, staticRenderFns } from "./DepartmentListSelector.vue?vue&type=template&id=50cabbb7&scoped=true&"
import script from "./DepartmentListSelector.vue?vue&type=script&lang=ts&"
export * from "./DepartmentListSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentListSelector.vue?vue&type=style&index=0&id=50cabbb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cabbb7",
  null
  
)

export default component.exports